import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function PhoneDisabledIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 13 13" htmlColor={Color.Body} {...props}>
      <path d="M9.403 10.63 6.957 8.466a9.3 9.3 0 0 1-2.359 1.29 7.2 7.2 0 0 1-2.51.457q-.27 0-.4-.132a.45.45 0 0 1-.128-.33V8.323a.4.4 0 0 1 .12-.295.57.57 0 0 1 .308-.161l1.384-.25a.8.8 0 0 1 .335.023.7.7 0 0 1 .293.15l1.12.997a9 9 0 0 0 1.296-.797L1.14 3.327a.3.3 0 0 1-.106-.23.3.3 0 0 1 .106-.235.38.38 0 0 1 .263-.095q.154 0 .262.095l8.263 7.303a.3.3 0 0 1 .106.23.3.3 0 0 1-.106.235.38.38 0 0 1-.262.095.38.38 0 0 1-.263-.095M8.178 7.367l-.533-.471q.189-.205.399-.478.21-.275.353-.5l-1.15-.99a.47.47 0 0 1-.155-.25.6.6 0 0 1-.01-.279l.286-1.296a.48.48 0 0 1 .183-.272.54.54 0 0 1 .334-.106H9.51q.224 0 .374.135.15.134.15.332 0 1.097-.5 2.177a7.6 7.6 0 0 1-1.356 1.998" />
    </MuiSvgIcon>
  );
}
export default PhoneDisabledIcon;
